import axios from "axios";
import { baseUrl } from "../assets/Animations";
import { getRequestHeaders } from "../api";

export const getNotes = async (typeOfNotes, id) => {
    return axios
      .get(`${baseUrl}/notes/${typeOfNotes}/${id}`)
      .then((res) => {
        let sortedData = res.data.sort((a, b) => {
          return new Date(b.date) - new Date(a.date);
        });
        return sortedData;
      })
      .catch((err) => {
        console.log(err);
      });
}

export const getStatusHistoryLogsForFamily = async (familyId) => {
    return axios
      .get(`${baseUrl}/status-history-logs/family/${familyId}`, getRequestHeaders())
      .then((res) => {
        let sortedData = res.data.sort((a, b) => {
          return new Date(a.effectiveDate || a.date) - new Date(b.effectiveDate || b.date);
        });
        return sortedData;
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
}

export const getTeacherAssignmentHistoryForFamily = async (familyId) => {
    return axios
      .get(`${baseUrl}/teacher-assignment-history/family/${familyId}`, getRequestHeaders())
      .then((res) => {
        let sortedData = res.data.sort((a, b) => {
          return new Date(a.changedAt || a.date) - new Date(b.changedAt || b.date);
        });
        return sortedData;
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
}

export const getTeacherDirectoryBySchool = async (school) => {
    if (!school) {
      return [];
    }

    return axios
      .get(`${baseUrl}/teachersbyschool/${String(school).toLowerCase()}`, getRequestHeaders())
      .then((res) => res.data || [])
      .catch((err) => {
        console.log(err);
        return [];
      });
}

export const createNote = async (noteInfo, callback) => {
    return axios
      .post(`${baseUrl}/notes`, {
        note: {
          id: Math.random().toString(16).slice(2),
          date: new Date(),
          type: noteInfo.type,
          author: noteInfo.author,
          important: noteInfo.important,
          connections: noteInfo.connections,
          details: noteInfo.details,
          applicationId: noteInfo.applicationId,
          invoiceId: noteInfo.invoiceId,
          onboardingId: noteInfo.onboardingId,
          familyId: noteInfo.familyId,
          tasksId: noteInfo.tasksId,
          teacherId: noteInfo.teacherId,
          timesheetId: noteInfo.timesheetId,
          workflowId: noteInfo.workflowId,
          miscId1: noteInfo.miscId1,
          miscId2: noteInfo.miscId2,
          miscId3: noteInfo.miscId3,
          miscId4: noteInfo.miscId4,
          miscId5: noteInfo.miscId5,
          miscId6: noteInfo.miscId6,
          miscId7: noteInfo.miscId7,
          miscId8: noteInfo.miscId8,
          miscId9: noteInfo.miscId9,
          miscId10: noteInfo.miscId10,
        },
      })
      .then((res) => {
        return res.data
      })
      .catch((err) => {
        console.log(err);
      });
}

export const updateNote = async (noteInfo) => {
    return axios
      .put(`${baseUrl}/notes/${noteInfo.id}`, {
        note: noteInfo
      })
      .then((res) => {
        return res.data
      })
      .catch((err) => {
        console.log(err);
      });
}

export const deleteNote = async (noteInfo) => {
    return axios
      .delete(`${baseUrl}/notes/${noteInfo.id}`)
      .then((res) => {
        return res.data
      })
      .catch((err) => {
        console.log(err);
      });
}
